<!-- vue d'accueil des chronocodes, présentation des templates -->
<wiz-v-divider width="100%" height="100%" gap="0" class="section-container-parent"> <!--c'est une sous-vue-->
  <widget-renderer
    width="100%"
    class="view-widget"
    [title]="'$.chronocode.home.title.$'"
    [description]="'$.chronocode.home.description.$'"
  ></widget-renderer>

  <wiz-vgroup width="100%" height="100%" class="section-container" gap="0">
    <!-- modèles tout prêt -->
    <wiz-hgroup width="100%" height="100%">
      <multi-display code="chronoSampleMD" #examplesMultiDisplay width="100%" height="100%" 
      [config]="examplesMultiConfig">
        <wiz-hgroup target="header-title" width="100%" [horizontalAlign]="'start'">
          <wiz-label [wizLabel]="'$.common.example.title.$'" class="titleLabel"></wiz-label>
        </wiz-hgroup>
      </multi-display>
    </wiz-hgroup>

    <wiz-hgroup width="100%" horizontalAlign="end" height="44px" verticalAlign="center">
      <wiz-button
        #btnMoreExample
        [wizLabel]="'$.chronocode.explore.example.$'"
        [wizIcon]="'icon-arrow-right'"
        [iconPlacement]="'right'"
      ></wiz-button>
    </wiz-hgroup>
  </wiz-vgroup>
</wiz-v-divider>
